const STORAGE_KEY = "dualflip_commercial_participants_v1";

const readStore = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

const writeStore = (store) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
};

export const saveCommercialConnection = (connection) => {
  if (!connection?.sessionId || !connection?.participantId || !connection?.participantToken) return;
  const store = readStore();
  store[connection.sessionId] = {
    sessionId: connection.sessionId,
    participantId: connection.participantId,
    participantToken: connection.participantToken,
    inviteCode: connection.inviteCode,
    savedAt: new Date().toISOString(),
  };
  writeStore(store);
};

export const getCommercialConnectionByInvite = (inviteCode) => {
  const normalized = String(inviteCode || "").trim().toUpperCase();
  return Object.values(readStore()).find((item) => item?.inviteCode === normalized) || null;
};

export const getMostRecentCommercialConnection = () =>
  Object.values(readStore()).sort((a, b) => String(b.savedAt).localeCompare(String(a.savedAt)))[0] || null;

export const removeCommercialConnection = (sessionId) => {
  const store = readStore();
  delete store[sessionId];
  writeStore(store);
};
